import React from "react";

export default function ComeBackFromGoogle() {
  const params = new URLSearchParams(window.location.search);
  const url = process.env.REACT_APP_DOMAIN;
  if (!params.has("test")) {
    window.location.replace(url);
  }
  localStorage.setItem("token", params.get("token"));
  window.location.replace(url);

  return <></>;
}
